export default __webpack_public_path__ + "static/media/blacklist.14b5a0ab.svg";